import { Component, computed, OnDestroy, OnInit, Signal, signal } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Subject, takeUntil } from 'rxjs';
import { HTTPTransactionService } from '../../../services/http/http-transaction.service';

@Component({
  selector: 'app-http-transaction-loading',
  templateUrl: './http-transaction-loading.component.html',
  styleUrl: './http-transaction-loading.component.scss',
  standalone: true,
  imports: [MatProgressSpinnerModule],
})
export class HTTPTransactionLoadingComponent implements OnInit, OnDestroy {
  private readonly destroy$ = new Subject<void>();
  private readonly activeTransactions = signal<string[]>([]);

  readonly isLoading: Signal<boolean> = computed(() => this.activeTransactions().length > 0);

  constructor(private readonly httpTransactionService: HTTPTransactionService) {}

  public ngOnInit(): void {
    this.httpTransactionService
      .getHttpRequestState()
      .pipe(takeUntil(this.destroy$))
      .subscribe((transactions) => {
        this.activeTransactions.set(transactions);
      });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
